<template>
  <div>
    <b-alert variant="danger" v-if="productDetail && productDetail.reject_reason" show>
      <div class="alert-body">
        <span>{{ productDetail.reject_reason }}</span>
        <div
          class="italic"
          v-if="productDetail.reject_date"
        >{{ moment(productDetail.reject_date).format("DD/MM/YYYY") }}</div>
      </div>
    </b-alert>
    <b-card class="product-add-wrapper">
      <b-form-group class="cs-checkbox">
        <b-form-checkbox
          v-model="isRequestToVerify"
          :disabled="
            productDetail &&
            productDetail.id &&
            productDetail.status > PRODUCT_ON_HODO.UNAVAILABLE
          "
        >{{ $t("lbl_request_to_verify") }}</b-form-checkbox>
      </b-form-group>
      <b-tabs pills>
        <b-tab active>
          <template #title>
            <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">{{ $t("lbl_product_info")[getProductTypeData()] }}</span>
          </template>
          <div class="mt-2 pt-75" :class="{ disable: isDisableEdit }">
            <validation-observer ref="addProductValidation">
              <!-- form -->
              <b-form>
                <b-row>
                  <b-col cols="12" md="4" xxl="3" order-md="last">
                    <b-media no-body vertical-align="center" class="flex-column mb-2">
                      <b-media-body class="w-100">
                        <div
                          class="preview-image border rounded mb-1"
                          @click="triggerChoosePreviewImage"
                        >
                          <div
                            v-if="previewImg"
                            v-b-tooltip="{
                              title: $t('lbl_remove_image'),
                              placement: 'bottom',
                              variant: 'danger',
                            }"
                            class="preview-image__clear d-flex flex-column position-absolute"
                            @click.stop="removeImage"
                          >
                            <feather-icon class="m-auto" size="16" icon="XIcon" />
                          </div>
                          <b-img
                            class="preview-image__item w-100 rounded"
                            v-show="previewImg"
                            :src="previewImg"
                            @error="(e) => appUtils.onHandleErrorLoadImage(e)"
                          />
                          <div
                            class="preview-image__item cursor-pointer w-100"
                            v-show="!previewImg"
                          >
                            <div class="m-auto text-center">
                              <feather-icon size="32" icon="ImageIcon" />
                              <div class="text-center mt-1">{{ $t("lbl_feature_image") }}</div>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex flex-wrap thumbs-image" style="margin: 0 -4px">
                          <div
                            class="thumbs-image__item"
                            v-for="(thumb, index) in thumbsImg"
                            :key="`thumb_${index}`"
                            style="padding: 0 4px"
                          >
                            <div
                              class="thumbs-image__item-wrap position-relative d-flex cursor-pointer"
                            >
                              <b-img class="w-100 border rounded" :src="thumb.url" />
                              <div class="thumbs-image__clear" @click="removeThumbImg(index)">
                                <feather-icon class="m-auto" size="16" icon="XIcon" />
                              </div>
                            </div>
                          </div>
                          <div
                            class="thumbs-image__item d-flex"
                            style="padding: 0 4px"
                            @click="triggerChooseThumbImage"
                          >
                            <div
                              class="thumbs-image__item-wrap position-relative border rounded d-flex flex-grow w-100 cursor-pointer"
                            >
                              <feather-icon class="m-auto" size="20" icon="PlusIcon" />
                            </div>
                          </div>
                        </div>
                        <small class="text-muted">{{ $t("lbl_required_image_resolution") }}</small>
                        <input
                          hidden
                          ref="refInputEl"
                          type="file"
                          accept=".jpg, .png"
                          :placeholder="$t('lbl_choose_file')"
                          @input="handleSelectPreviewImage"
                        />
                        <input
                          hidden
                          ref="refInputThumbEl"
                          type="file"
                          multiple
                          accept=".jpg, .png"
                          :placeholder="$t('lbl_choose_file')"
                          @input="handleSelectThumbsImage"
                        />
                      </b-media-body>
                    </b-media>
                    <!-- <b-form-group label="Brand" class="mb-2">
                    <validation-provider #default="{ errors }" name="Brand" rules="required">
                      <b-form-input v-model="form.brand" />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                    </b-form-group>-->
                  </b-col>
                  <b-col cols="12" md="8" xxl="9" order-md="first">
                    <b-row>
                      <!-- <b-col cols="12">
                        <h5
                          class="border-left-primary pl-50 mb-1"
                          style="border-left-width: 4px"
                        >
                          {{ $t("lbl_product_type") }}
                        </h5>
                        <b-form-group v-slot="{ ariaDescribedby }" class="mb-2">
                          <b-form-radio-group
                            v-model="form.type"
                            :aria-describedby="ariaDescribedby"
                            name="product-type-radios"
                            @change="handleChangeType"
                          >
                            <b-form-radio :value="PRODUCT_TYPES.PRODUCT">{{
                              $t(Object.keys(PRODUCT_TYPES)[0])
                            }}</b-form-radio>
                            <b-form-radio :value="PRODUCT_TYPES.SERVICE">{{
                              $t(Object.keys(PRODUCT_TYPES)[1])
                            }}</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </b-col>-->

                      <b-col cols="12">
                        <h5
                          class="border-left-primary pl-50 mb-2"
                          style="border-left-width: 4px"
                        >{{ $t("lbl_product_detail") }}</h5>
                      </b-col>

                      <b-col cols="12" class="flex" v-if="form.type === PRODUCT_TYPES.PRODUCT">
                        <b-form-group>
                          <b-form-checkbox
                            v-model="form.is_medicine"
                            :disabled="isDisableEdit"
                            @change="handleChangeIsMedicine"
                          >{{ $t("Sản phẩm là thuốc") }}</b-form-checkbox>
                        </b-form-group>
                        <b-form-group v-if="form.is_medicine" class="ml-2">
                          <b-form-checkbox
                            v-model="form.is_prescription_required"
                            :disabled="isDisableEdit"
                          >{{ $t("lbl_this_is_a_prescription_medicine") }}</b-form-checkbox>
                        </b-form-group>
                        <!-- <b-form-group class="ml-2">
                          <b-form-checkbox
                            v-model="form.view_web"
                            :disabled="isDisableEdit"
                            >{{ $t("lbl_is_view_web") }}</b-form-checkbox
                          >
                        </b-form-group>-->
                      </b-col>
                      <b-col v-else cols="12"></b-col>

                      <b-col :cols="form.type === PRODUCT_TYPES.PRODUCT ? 6 : 12">
                        <b-form-group
                          :label="$t('lbl_product_name')[getProductTypeData()]"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_product_name')[getProductTypeData()]"
                            rules="required"
                          >
                            <b-form-input v-model="form.name" @update="generateSlug" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          v-if="form.type === PRODUCT_TYPES.SERVICE"
                          :label="
                            $t('lbl_product_name__english_')[
                              getProductTypeData()
                            ]
                          "
                          class="mb-2"
                        >
                          <b-form-input v-model="form.product_multilanguage[0].name" />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6" v-if="form.type === PRODUCT_TYPES.PRODUCT">
                        <b-form-group :label="$t('lbl_register_number')" class="mb-2">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_register_number')"
                          >
                            <b-form-input type="text" v-model="form.registration_number" />
                            <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col v-else cols="12"></b-col>
                      <b-col cols="12">
                        <b-form-group :label="$t('lbl_slug')" class="mb-2 required">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_slug')"
                            rules="required"
                          >
                            <b-input-group :prepend="`${domain}products/`">
                              <b-form-input v-model="form.slug" />
                              <b-input-group-append>
                                <b-button
                                  variant="outline-primary"
                                  @click="generateSlug"
                                >{{ $t("lbl_generate") }}</b-button>
                              </b-input-group-append>
                            </b-input-group>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6">
                        <b-form-group class="mb-2 required">
                          <div class="flex gap-1 items-center" style="padding-bottom: 8px">
                            <label
                              class="mb-0 required"
                              style="font-size: 14px; color: rgb(110, 107, 123)"
                            >{{ $t("lbl_sku")[getProductTypeData()] }}</label>
                            <svg
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              v-b-tooltip.hover.top="
                                `Mã SKU là mã không trùng lặp để định danh giữa các sản phẩm.`
                              "
                              width="16"
                              height="16"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.75 22C17.75 22.1989 17.671 22.3897 17.5303 22.5303C17.3897 22.671 17.1989 22.75 17 22.75C16.5359 22.75 16.0908 22.5656 15.7626 22.2374C15.4344 21.9092 15.25 21.4641 15.25 21V16C15.25 15.9337 15.2237 15.8701 15.1768 15.8232C15.1299 15.7763 15.0663 15.75 15 15.75C14.8011 15.75 14.6103 15.671 14.4697 15.5303C14.329 15.3897 14.25 15.1989 14.25 15C14.25 14.8011 14.329 14.6103 14.4697 14.4697C14.6103 14.329 14.8011 14.25 15 14.25C15.4641 14.25 15.9093 14.4344 16.2374 14.7626C16.5656 15.0908 16.75 15.5359 16.75 16V21C16.75 21.0663 16.7763 21.1299 16.8232 21.1768C16.8701 21.2237 16.9337 21.25 17 21.25C17.1989 21.25 17.3897 21.329 17.5303 21.4697C17.671 21.6103 17.75 21.8011 17.75 22ZM15.5 11.75C15.7472 11.75 15.9889 11.6767 16.1945 11.5393C16.4 11.402 16.5602 11.2068 16.6549 10.9784C16.7495 10.7499 16.7742 10.4986 16.726 10.2561C16.6778 10.0137 16.5587 9.79093 16.3839 9.61612C16.2091 9.4413 15.9863 9.32225 15.7439 9.27402C15.5014 9.22579 15.2501 9.25054 15.0217 9.34515C14.7932 9.43976 14.598 9.59998 14.4607 9.80554C14.3233 10.0111 14.25 10.2528 14.25 10.5C14.25 10.8315 14.3817 11.1495 14.6161 11.3839C14.8505 11.6183 15.1685 11.75 15.5 11.75ZM28.75 16C28.75 18.5217 28.0022 20.9868 26.6012 23.0835C25.2003 25.1802 23.209 26.8144 20.8792 27.7795C18.5495 28.7445 15.9859 28.997 13.5126 28.505C11.0393 28.0131 8.76751 26.7987 6.98439 25.0156C5.20127 23.2325 3.98696 20.9607 3.49499 18.4874C3.00303 16.0141 3.25552 13.4505 4.22054 11.1208C5.18556 8.79103 6.81976 6.79975 8.91648 5.39876C11.0132 3.99777 13.4783 3.25 16 3.25C19.3803 3.25397 22.621 4.59854 25.0112 6.98877C27.4015 9.379 28.746 12.6197 28.75 16ZM27.25 16C27.25 13.775 26.5902 11.5999 25.354 9.74984C24.1179 7.89978 22.3609 6.45784 20.3052 5.60636C18.2495 4.75487 15.9875 4.53208 13.8052 4.96617C11.623 5.40025 9.6184 6.47171 8.04505 8.04505C6.47171 9.61839 5.40025 11.6229 4.96617 13.8052C4.53209 15.9875 4.75488 18.2495 5.60636 20.3052C6.45785 22.3609 7.89979 24.1179 9.74984 25.354C11.5999 26.5902 13.775 27.25 16 27.25C18.9827 27.2467 21.8422 26.0604 23.9513 23.9513C26.0604 21.8422 27.2467 18.9827 27.25 16Z"
                                fill="#0C0C0C"
                              />
                            </svg>
                          </div>
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_sku')[getProductTypeData()]"
                            rules="required"
                          >
                            <b-form-input v-model="form.sku" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="6" class="flex">
                        <b-form-group class="mb-2 w-full required">
                          <div class="flex gap-1 items-center" style="padding-bottom: 8px">
                            <label
                              class="mb-0 required"
                              style="font-size: 14px; color: rgb(110, 107, 123)"
                            >{{ $t("lbl_category") }}</label>
                            <svg
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              v-b-tooltip.hover.top="
                                'Danh mục là tập hợp các sản phẩm được nhóm lại với nhau bởi sự tương đồng dựa trên các tiêu chí như cùng chức năng, cùng ngành hàng/ chủng loại,....'
                              "
                              width="16"
                              height="16"
                              viewBox="0 0 32 32"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M17.75 22C17.75 22.1989 17.671 22.3897 17.5303 22.5303C17.3897 22.671 17.1989 22.75 17 22.75C16.5359 22.75 16.0908 22.5656 15.7626 22.2374C15.4344 21.9092 15.25 21.4641 15.25 21V16C15.25 15.9337 15.2237 15.8701 15.1768 15.8232C15.1299 15.7763 15.0663 15.75 15 15.75C14.8011 15.75 14.6103 15.671 14.4697 15.5303C14.329 15.3897 14.25 15.1989 14.25 15C14.25 14.8011 14.329 14.6103 14.4697 14.4697C14.6103 14.329 14.8011 14.25 15 14.25C15.4641 14.25 15.9093 14.4344 16.2374 14.7626C16.5656 15.0908 16.75 15.5359 16.75 16V21C16.75 21.0663 16.7763 21.1299 16.8232 21.1768C16.8701 21.2237 16.9337 21.25 17 21.25C17.1989 21.25 17.3897 21.329 17.5303 21.4697C17.671 21.6103 17.75 21.8011 17.75 22ZM15.5 11.75C15.7472 11.75 15.9889 11.6767 16.1945 11.5393C16.4 11.402 16.5602 11.2068 16.6549 10.9784C16.7495 10.7499 16.7742 10.4986 16.726 10.2561C16.6778 10.0137 16.5587 9.79093 16.3839 9.61612C16.2091 9.4413 15.9863 9.32225 15.7439 9.27402C15.5014 9.22579 15.2501 9.25054 15.0217 9.34515C14.7932 9.43976 14.598 9.59998 14.4607 9.80554C14.3233 10.0111 14.25 10.2528 14.25 10.5C14.25 10.8315 14.3817 11.1495 14.6161 11.3839C14.8505 11.6183 15.1685 11.75 15.5 11.75ZM28.75 16C28.75 18.5217 28.0022 20.9868 26.6012 23.0835C25.2003 25.1802 23.209 26.8144 20.8792 27.7795C18.5495 28.7445 15.9859 28.997 13.5126 28.505C11.0393 28.0131 8.76751 26.7987 6.98439 25.0156C5.20127 23.2325 3.98696 20.9607 3.49499 18.4874C3.00303 16.0141 3.25552 13.4505 4.22054 11.1208C5.18556 8.79103 6.81976 6.79975 8.91648 5.39876C11.0132 3.99777 13.4783 3.25 16 3.25C19.3803 3.25397 22.621 4.59854 25.0112 6.98877C27.4015 9.379 28.746 12.6197 28.75 16ZM27.25 16C27.25 13.775 26.5902 11.5999 25.354 9.74984C24.1179 7.89978 22.3609 6.45784 20.3052 5.60636C18.2495 4.75487 15.9875 4.53208 13.8052 4.96617C11.623 5.40025 9.6184 6.47171 8.04505 8.04505C6.47171 9.61839 5.40025 11.6229 4.96617 13.8052C4.53209 15.9875 4.75488 18.2495 5.60636 20.3052C6.45785 22.3609 7.89979 24.1179 9.74984 25.354C11.5999 26.5902 13.775 27.25 16 27.25C18.9827 27.2467 21.8422 26.0604 23.9513 23.9513C26.0604 21.8422 27.2467 18.9827 27.25 16Z"
                                fill="#0C0C0C"
                              />
                            </svg>
                          </div>
                          <template>
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_category')"
                              rules="required"
                            >
                              <v-select
                                id="category-product"
                                v-model="categorySelected"
                                :label="
                                  currLanguage == 'en' ? 'name_en' : 'name'
                                "
                                value="id"
                                :clearable="true"
                                :options="categoriesOption"
                                :calculate-position="withPopper"
                              >
                                <template slot="no-options">{{ $t("lbl_no_option") }}</template>
                              </v-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </template>
                        </b-form-group>
                        <!-- <div class="append_cate">
                          <b-button
                            v-b-tooltip.hover
                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                            variant="outline-primary"
                            class="btn-add-category"
                            @click="openCateModal(TYPE_CATE.category)"
                          >
                            <feather-icon size="22" icon="PlusIcon" />
                          </b-button>
                        </div>-->
                      </b-col>

                      <template v-if="form.type === PRODUCT_TYPES.PRODUCT">
                        <b-col v-show="form.is_medicine" cols="6">
                          <b-form-group :label="$t('lbl_dosage_form')" class="mb-2">
                            <v-select
                              id="dosage_form"
                              push-tags
                              taggable
                              v-model="form.dosage_form_id"
                              label="name"
                              :reduce="(option) => option.id"
                              value="id"
                              :clearable="true"
                              :options="dosageFormsOption"
                              :calculate-position="withPopper"
                              @search="handleLog"
                            >
                              <template slot="no-options">
                                {{
                                $t("lbl_no_option")
                                }}
                              </template>
                              <template v-slot:option="option">
                                {{ option.name }}
                                {{ !option.id ? "(Tạo)" : "" }}
                              </template>
                            </v-select>
                          </b-form-group>
                        </b-col>
                        <b-col cols="6">
                          <b-form-group :label="$t('lbl_packaging')" class="mb-2 relative">
                            <validation-provider #default="{ errors }" :name="$t('lbl_packaging')">
                              <v-select
                                id="dosage_form"
                                push-tags
                                taggable
                                @search="handleLog"
                                :reduce="(option) => option.id"
                                v-model="form.specification_id"
                                label="name"
                                value="id"
                                :clearable="true"
                                :options="specificationsOption"
                                :calculate-position="withPopper"
                              >
                                <template slot="no-options">
                                  {{
                                  $t("lbl_no_option")
                                  }}
                                </template>
                                <template v-slot:option="option">
                                  {{ option.name }}
                                  {{ !option.id ? "(Tạo)" : "" }}
                                </template>
                              </v-select>
                              <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                              <div
                                v-if="form.specification_id"
                                @click="form.specification_id = 0"
                                class="cs-close-icon"
                              >
                                <feather-icon icon="XIcon" />
                              </div>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </template>
                      <template v-else>
                        <b-col cols="12" />
                      </template>

                      <b-col cols="12" v-if="form.type === PRODUCT_TYPES.PRODUCT">
                        <b-card bg-variant="light">
                          <b-row
                            v-for="(item, index) in form.product_variants"
                            :id="item.id || item.code || index"
                            :key="item.id || item.code || index"
                            :set="(isMinimumUnit = item.conversion_rate === 1)"
                          >
                            <b-col cols="12" md="4" class="px-50">
                              <b-form-group :label="$t('lbl_unit_price')" class="required">
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`input-price-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_unit_price')"
                                  rules="required"
                                >
                                  <b-input-group append="VNĐ">
                                    <cleave
                                      v-model="item.price"
                                      class="form-control"
                                      :id="`input-price-${
                                        item.id || item.code || index
                                      }`"
                                      :raw="false"
                                      :options="cleaveOptions.number"
                                      placeholder="10,000"
                                      @input="
                                        (value) =>
                                          handleSetPriceUnit(value, index)
                                      "
                                    />
                                  </b-input-group>
                                  <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col cols="12" md="4" class="px-50">
                              <b-form-group
                                :label="
                                  isMinimumUnit
                                    ? $t('lbl_minimum_unit')
                                    : $t('lbl_unit')
                                "
                                class="w-100 required relative"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`select-unit-${
                                    item.id || item.code || index
                                  }`"
                                  :name="
                                    isMinimumUnit
                                      ? $t('lbl_minimum_unit')
                                      : $t('lbl_unit')
                                  "
                                  rules="required"
                                >
                                  <v-select
                                    class="bg-white"
                                    push-tags
                                    taggable
                                    :createOption="handleLog"
                                    v-model="item.unit"
                                    label="name"
                                    value="unit_id"
                                    append-to-body
                                    :id="`select-unit-${
                                      item.id || item.code || index
                                    }`"
                                    :clearable="false"
                                    :options="unitsOption"
                                    :calculate-position="withPopper"
                                    @input="
                                      (value) => handleSelectUnit(value, index)
                                    "
                                  >
                                    <template slot="no-options">{{ $t("lbl_no_option") }}</template>
                                    <template v-slot:option="option">
                                      {{ option.name }}
                                      {{ !option.id ? "(Tạo)" : "" }}
                                    </template>
                                  </v-select>
                                  <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                                  <div
                                    v-if="item.unit_id"
                                    @click="item.unit = 0"
                                    class="cs-close-icon"
                                  >
                                    <feather-icon icon="XIcon" />
                                  </div>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col
                              v-if="
                                typeof minimumUnit !== 'undefined' &&
                                !isMinimumUnit
                              "
                              cols="12"
                              md="2"
                              class="px-50"
                            >
                              <b-form-group
                                :label="$t('lbl_conversion_rate')"
                                class="w-100 required"
                              >
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`select-unit-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_conversion_rate')"
                                  rules="required"
                                >
                                  <b-input-group :append="minimumUnit.unit.name">
                                    <cleave
                                      v-model="item.conversion_rate"
                                      class="form-control"
                                      :id="`input-conversion-rate-${
                                        item.id || item.code || index
                                      }`"
                                      :raw="false"
                                      placeholder="10"
                                      :options="cleaveOptions.number"
                                    />
                                  </b-input-group>
                                  <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <b-col cols="12" md="2" class="px-50">
                              <div class="d-flex">
                                <div class="text-nowrap ml-1" style="margin-top: 27.42px">
                                  <b-button
                                    v-if="
                                      form.product_variants.length > 1 &&
                                      !isMinimumUnit &&
                                      !productId
                                    "
                                    v-b-tooltip.hover
                                    :title="$t('lbl_remove')"
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-danger"
                                    class="p-50"
                                    @click="
                                      removeItem(
                                        index,
                                        form.product_variants,
                                        handleRemoveVariant(item.id)
                                      )
                                    "
                                  >
                                    <feather-icon size="22" icon="Trash2Icon" />
                                    <span class="sr-only">{{ $t("lbl_remove") }}</span>
                                  </b-button>
                                </div>
                              </div>
                            </b-col>
                            <b-col v-if="form.product_variants.length > 1" cols="12" class="px-50">
                              <b-form-group class="mb-0">
                                <b-form-radio
                                  :disabled="isDisableEdit"
                                  v-model="item.is_default"
                                  name="unit-radios"
                                  :value="2"
                                  @change="
                                    (value) =>
                                      handleSetDefaultPriceUnit(value, index)
                                  "
                                >{{ $t("lbl_default_price") }}</b-form-radio>
                              </b-form-group>
                            </b-col>
                            <b-col
                              v-if="
                                index !== form.product_variants.length - 1 &&
                                form.product_variants.length > 1
                              "
                              cols="12"
                            >
                              <hr />
                            </b-col>
                            <b-col cols="12" class="px-50" :class="{ 'mt-2': index !== 0 }">
                              <div class="d-flex justify-start">
                                <div class="text-nowrap">
                                  <b-button
                                    v-if="
                                      index === form.product_variants.length - 1
                                    "
                                    v-b-tooltip.hover
                                    :title="$t('lbl_add_new')"
                                    v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                    variant="outline-primary"
                                    class="p-50"
                                    style="border: none !important"
                                    @click="
                                      addNewUnitItem(form.product_variants)
                                    "
                                  >
                                    <feather-icon
                                      size="18"
                                      icon="PlusIcon"
                                      style="margin-bottom: 2.5px"
                                    />
                                    <span
                                      style="
                                        line-height: 22px;
                                        display: inline-block;
                                        margin-left: 5px;
                                      "
                                    >{{ $t("lbl_add_new") }}</span>
                                  </b-button>
                                </div>
                              </div>
                            </b-col>
                          </b-row>
                        </b-card>
                      </b-col>

                      <template v-else>
                        <b-col cols="12" v-if="form.type === PRODUCT_TYPES.SERVICE">
                          <b-card bg-variant="light">
                            <b-row
                              v-for="(item, index) in form.product_variants"
                              :id="item.id || item.code || index"
                              :key="item.id || item.code || index"
                            >
                              <b-col cols="12" md="3" class="px-50" v-if="item.isSaleSelected">
                                <b-form-group :label="$t('lbl_old_price')" class="required">
                                  <validation-provider
                                    #default="{ errors }"
                                    :vid="`input-old-price-${
                                      item.id || item.code || index
                                    }`"
                                    :name="$t('lbl_old_price')"
                                    rules="required"
                                  >
                                    <b-input-group append="VNĐ">
                                      <cleave
                                        v-model="item.old_price"
                                        class="form-control"
                                        :id="`input-old-price-${
                                          item.id || item.code || index
                                        }`"
                                        :raw="false"
                                        :options="cleaveOptions.number"
                                        placeholder="10,000"
                                      />
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" :md="item.isSaleSelected ? 3 : 4" class="px-50">
                                <b-form-group
                                  :label="
                                    $t('lbl_price_service')[
                                      getProductTypeData()
                                    ]
                                  "
                                  class="required"
                                >
                                  <validation-provider
                                    #default="{ errors }"
                                    :vid="`input-price-${
                                      item.id || item.code || index
                                    }`"
                                    :name="
                                      $t('lbl_price_service')[
                                        getProductTypeData()
                                      ]
                                    "
                                    rules="required"
                                  >
                                    <b-input-group append="VNĐ">
                                      <cleave
                                        v-model="item.price"
                                        class="form-control"
                                        :id="`input-price-${
                                          item.id || item.code || index
                                        }`"
                                        :raw="false"
                                        :options="cleaveOptions.number"
                                        placeholder="10,000"
                                        @input="
                                          (value) =>
                                            handleSetPriceUnit(value, index)
                                        "
                                      />
                                    </b-input-group>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" :md="item.isSaleSelected ? 3 : 4" class="px-50">
                                <b-form-group :label="$t('lbl_units')" class="w-100 required">
                                  <validation-provider
                                    #default="{ errors }"
                                    :vid="`select-unit-${
                                      item.id || item.code || index
                                    }`"
                                    :name="$t('lbl_units')"
                                    rules="required"
                                  >
                                    <v-select
                                      class="bg-white"
                                      v-model="item.unit"
                                      :label="
                                        currLanguage == 'en'
                                          ? 'name_en'
                                          : 'name'
                                      "
                                      value="id"
                                      append-to-body
                                      taggable
                                      :id="`select-unit-${
                                        item.id || item.code || index
                                      }`"
                                      :clearable="true"
                                      :options="unitsOption"
                                      :calculate-position="withPopper"
                                      @input="
                                        (value) =>
                                          handleSelectUnit(value, index)
                                      "
                                    >
                                      <template slot="no-options">{{ $t("lbl_no_option") }}</template>
                                    </v-select>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" :md="item.isSaleSelected ? 3 : 4" class="px-50">
                                <div class="d-flex">
                                  <!-- <b-form-group :label="$t('lbl_units')" class="required">
            <validation-provider
              #default="{ errors }"
              :name="$t('lbl_units')"
              rules="required"
            >
              <b-input-group>
                <cleave
                  v-model="item.number_unit"
                  class="form-control"
                  :raw="false"
                  :options="cleaveOptions.number"
                  placeholder="10"
                  @input="(value) => handleSetUnitNumber(value, index)"
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
                                  </b-form-group>-->
                                  <div class="text-nowrap ml-1" style="margin-top: 27.42px">
                                    <b-button
                                      v-if="form.product_variants.length > 1"
                                      v-b-tooltip.hover
                                      :title="$t('lbl_remove')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-danger"
                                      class="p-50"
                                      @click="
                                        removeItem(
                                          index,
                                          form.product_variants,
                                          handleRemoveVariant(item.id)
                                        )
                                      "
                                    >
                                      <feather-icon size="22" icon="Trash2Icon" />
                                      <span class="sr-only">{{ $t("lbl_remove") }}</span>
                                    </b-button>
                                    <b-button
                                      v-if="
                                        index ===
                                        form.product_variants.length - 1
                                      "
                                      v-b-tooltip.hover
                                      :title="$t('lbl_add_new')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-primary"
                                      class="p-50 ml-50"
                                      @click="
                                        addNewUnitItem(form.product_variants)
                                      "
                                    >
                                      <feather-icon size="22" icon="PlusIcon" />
                                      <span class="sr-only">{{ $t("lbl_add_new") }}</span>
                                    </b-button>
                                  </div>
                                </div>
                              </b-col>
                              <!-- <b-col cols="12" class="px-50">
  <b-form-group class="mb-0">
    <validation-provider #default="{ errors }" name="On Sale">
      <b-form-checkbox v-model="item.isSaleSelected">On Sale</b-form-checkbox>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
                              </b-col>-->
                              <b-col
                                cols="12"
                                class="px-50"
                                v-if="form.product_variants.length > 1"
                              >
                                <b-form-group class="mb-0">
                                  <b-form-radio
                                    v-model="item.is_default"
                                    name="unit-radios"
                                    :value="2"
                                    @change="
                                      (value) =>
                                        handleSetDefaultPriceUnit(value, index)
                                    "
                                  >{{ $t("lbl_default_price") }}</b-form-radio>
                                </b-form-group>
                              </b-col>
                              <b-col
                                cols="12"
                                v-if="
                                  index !== form.product_variants.length - 1 &&
                                  form.product_variants.length > 1
                                "
                              >
                                <hr />
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                        <b-col cols="12" v-if="form.type === PRODUCT_TYPES.SERVICE">
                          <b-card bg-variant="light">
                            <div
                              class="font-weight-bold h4"
                              style="margin-left: -6px"
                            >{{ $t("lbl_other_costs") }}</div>
                            <b-row
                              v-for="(item, index) in form.other_expenses"
                              :id="item.id || item.code || index"
                              :key="item.id || item.code || index"
                            >
                              <b-col cols="12" :md="6" class="px-50">
                                <b-form-group :label="$t('lbl_cost_name')">
                                  <validation-provider
                                    #default="{ errors }"
                                    :name="$t('lbl_cost_name')"
                                  >
                                    <b-form-input v-model="item.name" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                  </validation-provider>
                                </b-form-group>
                              </b-col>
                              <b-col cols="12" :md="6" class="px-50">
                                <div class="d-flex">
                                  <b-form-group :label="$t('lbl_cost')">
                                    <validation-provider
                                      #default="{ errors }"
                                      :vid="`input-expense-${
                                        item.id || item.code || index
                                      }`"
                                      :name="$t('lbl_cost')"
                                    >
                                      <b-input-group append="VNĐ">
                                        <cleave
                                          v-model="item.value"
                                          class="form-control"
                                          :id="`input-expense-${
                                            item.id || item.code || index
                                          }`"
                                          :raw="false"
                                          :options="cleaveOptions.number"
                                          placeholder="10,000"
                                        />
                                      </b-input-group>
                                      <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                  </b-form-group>
                                  <div class="text-nowrap ml-1" style="margin-top: 27.42px">
                                    <b-button
                                      v-if="form.other_expenses.length > 1"
                                      v-b-tooltip.hover
                                      :title="$t('lbl_remove')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-danger"
                                      class="p-50"
                                      @click="
                                        removeItem(index, form.other_expenses)
                                      "
                                    >
                                      <feather-icon size="22" icon="Trash2Icon" />
                                      <span class="sr-only">{{ $t("lbl_remove") }}</span>
                                    </b-button>
                                    <b-button
                                      v-if="
                                        index === form.other_expenses.length - 1
                                      "
                                      v-b-tooltip.hover
                                      :title="$t('lbl_add_new')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-primary"
                                      class="p-50 ml-50"
                                      @click="
                                        addNewExpenseItem(form.other_expenses)
                                      "
                                    >
                                      <feather-icon size="22" icon="PlusIcon" />
                                      <span class="sr-only">{{ $t("lbl_add_new") }}</span>
                                    </b-button>
                                  </div>
                                </div>
                              </b-col>
                              <b-col
                                cols="12"
                                v-if="
                                  index !== form.other_expenses.length - 1 &&
                                  form.other_expenses.length > 1
                                "
                              >
                                <hr />
                              </b-col>
                            </b-row>
                          </b-card>
                        </b-col>
                      </template>

                      <b-col cols="12">
                        <h5 class="border-left-primary pl-50 mb-2" style="border-left-width: 4px">
                          {{
                          $t("lbl_origin")[getProductTypeData()] +
                          " / " +
                          $t("lbl_origination")
                          }}
                        </h5>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_brand')[getProductTypeData()]"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_brand')[getProductTypeData()]"
                            rules="required"
                          >
                            <v-select
                              id="brand-product"
                              v-model="form.brand_id"
                              label="name"
                              value="id"
                              :clearable="true"
                              push-tags
                              taggable
                              :options="brandsOption"
                              :calculate-position="withPopper"
                              @search="handleLog"
                              :reduce="(option) => option.id"
                            >
                              <template slot="no-options">{{ $t("lbl_no_option") }}</template>
                              <template v-slot:option="option">
                                {{ option.name }}
                                {{ !option.id ? "(Tạo)" : "" }}
                              </template>
                            </v-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group
                          :label="$t('lbl_manufacture')[getProductTypeData()]"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_manufacture')[getProductTypeData()]"
                          >
                            <v-select
                              id="brand-product"
                              v-model="form.manufacturer_id"
                              label="name"
                              value="id"
                              :clearable="true"
                              push-tags
                              taggable
                              :options="manufacturersOption"
                              :calculate-position="withPopper"
                              @search="handleLog"
                              :reduce="(option) => option.id"
                            >
                              <template slot="no-options">{{ $t("lbl_no_option") }}</template>
                              <template v-slot:option="option">
                                {{ option.name }}
                                {{ !option.id ? "(Tạo)" : "" }}
                              </template>
                            </v-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          v-if="form.type === PRODUCT_TYPES.SERVICE"
                          :label="
                            $t('lbl_manufacture__english_')[
                              getProductTypeData()
                            ]
                          "
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="
                              $t('lbl_manufacture__english_')[
                                getProductTypeData()
                              ]
                            "
                          >
                            <b-form-input
                              v-model="
                                form.product_multilanguage[0].manufacturer
                              "
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group :label="$t('lbl_origin')[getProductTypeData()]" class="mb-2">
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_origin')[getProductTypeData()]"
                          >
                            <v-select
                              id="origin"
                              v-model="form.origin_id"
                              label="name"
                              value="id"
                              :clearable="true"
                              push-tags
                              taggable
                              :options="originsOption"
                              :calculate-position="withPopper"
                              @search="handleLog"
                              :reduce="(option) => option.id"
                            >
                              <template slot="no-options">{{ $t("lbl_no_option") }}</template>
                              <template v-slot:option="option">
                                {{ option.name }}
                                {{ !option.id ? "(Tạo)" : "" }}
                              </template>
                            </v-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          v-if="form.type === PRODUCT_TYPES.SERVICE"
                          :label="
                            $t('lbl_origin__english_')[getProductTypeData()]
                          "
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="
                              $t('lbl_origin__english_')[getProductTypeData()]
                            "
                          >
                            <b-form-input v-model="form.product_multilanguage[0].origin" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <h5
                          class="border-left-primary pl-50 mb-2"
                          style="border-left-width: 4px"
                        >{{ $t("lbl_ingredients_description") }}</h5>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group :label="$t('lbl_summary')" class="mb-2">
                          <validation-provider #default="{ errors }" :name="$t('lbl_summary')">
                            <b-form-textarea v-model="form.short_desc" rows="3" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          v-if="form.type === PRODUCT_TYPES.SERVICE"
                          :label="$t('lbl_summary__english_')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_summary__english_')"
                          >
                            <b-form-textarea
                              v-model="form.product_multilanguage[0].short_desc"
                              rows="3"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group :label="$t('lbl_description')" class="mb-2">
                          <validation-provider #default="{ errors }" :name="$t('lbl_description')">
                            <quill-editor
                              v-model="form.description"
                              :options="optionsEditor"
                              :disabled="isDisableEdit"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-form-group
                          v-if="form.type === PRODUCT_TYPES.SERVICE"
                          :label="$t('lbl_description__english_')"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_description__english_')"
                          >
                            <quill-editor
                              v-model="
                                form.product_multilanguage[0].description
                              "
                              :options="optionsEditor"
                              :disabled="isDisableEdit"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <b-col cols="12">
                        <b-form-group
                          v-if="form.type === PRODUCT_TYPES.PRODUCT"
                          :label="$t('lbl_ingredients')"
                          class="mb-2"
                        >
                          <validation-provider #default="{ errors }" :name="$t('lbl_ingredients')">
                            <b-form-textarea
                              class="scrollbar"
                              v-model="form.ingredient"
                              rows="3"
                              max-rows="20"
                            />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                      </b-col>

                      <template
                        v-if="
                          form.type === PRODUCT_TYPES.PRODUCT &&
                          form.is_medicine
                        "
                      >
                        <b-col cols="12">
                          <h5
                            class="border-left-primary pl-50 mb-2"
                            style="border-left-width: 4px"
                          >{{ $t("lbl_indicative_contraindicated") }}</h5>
                        </b-col>

                        <b-col cols="12">
                          <b-form-group :label="$t('lbl_indicative')" class="mb-2">
                            <b-form-textarea
                              class="scrollbar"
                              v-model="form.indication"
                              rows="3"
                              max-rows="20"
                            />
                          </b-form-group>
                          <b-form-group :label="$t('lbl_contraindicated')" class="mb-2">
                            <b-form-textarea
                              class="scrollbar"
                              v-model="form.contraindicated"
                              rows="3"
                              max-rows="20"
                            />
                          </b-form-group>
                          <b-form-group :label="$t('lbl_note')" class="mb-2">
                            <validation-provider #default="{ errors }" :name="$t('lbl_note')">
                              <b-form-textarea
                                class="scrollbar"
                                v-model="form.notes"
                                rows="3"
                                max-rows="20"
                              />
                              <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </template>

                      <b-col cols="12">
                        <h5
                          v-if="form.type === PRODUCT_TYPES.SERVICE"
                          class="border-left-primary pl-50 mb-2"
                          style="border-left-width: 4px"
                        >{{ $t("lbl_others_setup") }}</h5>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group v-if="form.type === PRODUCT_TYPES.SERVICE">
                          <b-form-checkbox
                            v-model="isRequiredAttachment"
                          >{{ $t("lbl_require_attachment") }}</b-form-checkbox>
                        </b-form-group>
                        <b-form-group
                          v-if="
                            form.type === PRODUCT_TYPES.SERVICE &&
                            isRequiredAttachment
                          "
                          :label="`${$t('lbl_required_attachment_configs')}:`"
                          class="mb-2"
                        >
                          <validation-provider
                            #default="{ errors }"
                            name="Attachment"
                            :rules="isRequiredAttachment ? 'required' : ''"
                          >
                            <v-select
                              id="attachment-config"
                              v-model="attachmentConfigSelected"
                              label="title"
                              value="id"
                              :clearable="true"
                              :options="attachmentConfigs"
                              :calculate-position="withPopper"
                              @input="handleAttachmentSetDefaultData"
                            >
                              <template slot="no-options">{{ $t("lbl_no_option") }}</template>
                            </v-select>
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>

                        <b-form-group
                          v-if="
                            form.type === PRODUCT_TYPES.SERVICE &&
                            attachmentConfigSelected &&
                            attachmentConfigSelected.id === -1
                          "
                          :label="$t('lbl_title_name_attachment_config')"
                          class="mb-2 required"
                        >
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('lbl_title_name_attachment_config')"
                            rules="required"
                          >
                            <b-form-input v-model="attachMentTitleConfig" />
                            <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>
                        </b-form-group>
                        <b-card
                          v-if="
                            form.type === PRODUCT_TYPES.SERVICE &&
                            attachmentConfigSelected &&
                            attachmentConfigSelected.order_form_items
                          "
                          bg-variant="light"
                          class="cs-card"
                        >
                          <!-- <h4 class="mb-2">{{ $t('lbl_require_attachment') }}</h4> -->
                          <b-row
                            v-for="(
                              item, index
                            ) in attachmentConfigSelected.order_form_items"
                            :id="item.id || item.code || index"
                            :key="item.id || item.code || index"
                            ref="row"
                          >
                            <!-- Item Name -->
                            <b-col md="8">
                              <b-form-group class="mb-md-0">
                                <validation-provider
                                  #default="{ errors }"
                                  :vid="`input-${
                                    item.id || item.code || index
                                  }`"
                                  :name="$t('lbl_deliverable_documents_title')"
                                  rules="required"
                                >
                                  <b-form-input
                                    v-if="isDisabledAttachmentConfigs"
                                    type="text"
                                    v-model="item.name"
                                    :vid="`input-${
                                      item.id || item.code || index
                                    }`"
                                    :placeholder="
                                      $t('lbl_eg__config_handout_documents')
                                    "
                                    :disabled="isDisabledAttachmentConfigs"
                                  />
                                  <b-row v-else>
                                    <b-col>
                                      <b-form-input
                                        type="text"
                                        v-model="item.name"
                                        :placeholder="
                                          $t('lbl_eg__config_handout_documents')
                                        "
                                      />
                                    </b-col>
                                    <b-col>
                                      <b-form-file
                                        v-model="item.file"
                                        :state="Boolean(item.file)"
                                        placeholder="Chọn hoặc thả file vào đây"
                                        drop-placeholder="Drop file here..."
                                      ></b-form-file>
                                    </b-col>
                                  </b-row>

                                  <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                              </b-form-group>
                            </b-col>
                            <!-- Buttons -->
                            <b-col md="4">
                              <!-- <div class="d-none d-md-block pb-2 mb-50"></div> -->
                              <div>
                                <b-button
                                  v-b-tooltip.hover
                                  v-if="
                                    attachementItems.length > 1 &&
                                    !isDisabledAttachmentConfigs
                                  "
                                  :title="$t('lbl_remove')"
                                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                  variant="outline-danger"
                                  class="px-1 py-50 mr-75"
                                  @click="removeItem(index, attachementItems)"
                                >
                                  <feather-icon size="22" icon="Trash2Icon" />
                                  <span class="sr-only">{{ $t("lbl_remove") }}</span>
                                </b-button>
                                <b-button
                                  v-if="
                                    index === attachementItems.length - 1 &&
                                    !isDisabledAttachmentConfigs
                                  "
                                  v-b-tooltip.hover
                                  :title="$t('lbl_add_new')"
                                  v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                  variant="outline-primary"
                                  class="px-1 py-50"
                                  @click="addNewDeliverable(attachementItems)"
                                >
                                  <feather-icon size="22" icon="PlusIcon" />
                                  <span class="sr-only">{{ $t("lbl_add_new") }}</span>
                                </b-button>
                              </div>
                            </b-col>
                            <b-col
                              cols="12"
                              v-if="
                                index !== attachementItems.length - 1 &&
                                attachementItems.length > 1
                              "
                            >
                              <hr />
                            </b-col>
                          </b-row>
                        </b-card>
                        <div v-if="form.type === PRODUCT_TYPES.SERVICE">
                          <b-form-group :label="$t('lbl_delivery_progress')" class="mb-2 required">
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_delivery_progress')"
                              rules="required"
                            >
                              <v-select
                                id="category-product-delivery-status"
                                v-model="deliveryStatusSelected"
                                :label="
                                  currLanguage == 'en' ? 'title_en' : 'title'
                                "
                                value="id"
                                :clearable="true"
                                :options="deliveryStatusOptions"
                                :calculate-position="withPopper"
                                @input="handleSetDefaultData"
                              >
                                <template slot="no-options">{{ $t("lbl_no_option") }}</template>
                              </v-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-form-group
                            v-if="
                              deliveryStatusSelected &&
                              deliveryStatusSelected.id === -1
                            "
                            :label="$t('lbl_title_name_status_config')"
                            class="mb-2 required"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_title_name_status_config')"
                              rules="required"
                            >
                              <b-form-input v-model="statusTitleConfig" />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-card
                            bg-variant="light"
                            v-if="
                              deliveryStatusSelected !== null ||
                              deliveryDefinitionSelected !== null
                            "
                          >
                            <div
                              class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-2"
                            >
                              <h4 class="mb-md-0">{{ $t("lbl_service_deliverables") }}</h4>
                              <div v-if="false">
                                <b-button
                                  class="mr-50"
                                  v-b-tooltip.hover
                                  :title="$t('lbl_set_default_data')"
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="outline-primary"
                                  size="sm"
                                  @click="handleSetDefaultData"
                                >
                                  <feather-icon icon="PlusCircleIcon" />
                                  <span class="ml-50 sr-only">{{ $t("lbl_set_default_data") }}</span>
                                </b-button>
                                <b-button
                                  v-b-tooltip.hover
                                  :title="$t('lbl_reset_data')"
                                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                  variant="outline-danger"
                                  size="sm"
                                  @click="handleReset"
                                >
                                  <feather-icon icon="RefreshCwIcon" />
                                  <span class="ml-50 sr-only">{{ $t("lbl_reset_data") }}</span>
                                </b-button>
                              </div>
                            </div>

                            <!-- Add deliverable status -->
                            <div>
                              <h5 class="border-left-primary pl-50" style="border-left-width: 4px">
                                {{
                                $t(
                                "lbl_delivery_status_notification_check_list"
                                )
                                }}
                              </h5>
                              <b-card-text>
                                {{
                                $t(
                                "lbl_this_will_be_shown_to_your_customer_how_they_should_await_for_package_delivery"
                                )
                                }}
                              </b-card-text>
                              <b-row
                                v-for="(item, index) in deliverableStatus"
                                :id="item.id || item.code || index"
                                :key="item.id || item.code || index"
                                ref="row"
                              >
                                <!-- Item Name -->
                                <b-col md="8">
                                  <b-form-group
                                    :label="`${$t('lbl_step')} ${
                                      index + 1 < 10
                                        ? `0${index + 1}`
                                        : index + 1
                                    }`"
                                    class="mb-md-0"
                                  >
                                    <validation-provider
                                      #default="{ errors }"
                                      :vid="`input-${
                                        item.id || item.code || index
                                      }`"
                                      :name="
                                        $t('lbl_title_name_deliverable_status')
                                      "
                                      rules="required"
                                    >
                                      <b-form-input
                                        type="text"
                                        :value="
                                          currLanguage == 'en'
                                            ? getTitleStatusEn(
                                                item.delivery_state_step_multilanguage
                                              ) || item.title
                                            : item.title
                                        "
                                        :id="`input-${
                                          item.id || item.code || index
                                        }`"
                                        :placeholder="
                                          $t(
                                            'lbl_ex__receiver_order__processing__sending____'
                                          )
                                        "
                                        :disabled="isDisabledDeliverableStates"
                                      />
                                      <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                  </b-form-group>
                                </b-col>

                                <!-- Buttons -->
                                <b-col md="4">
                                  <div class="d-none d-md-block pb-2 mb-50"></div>
                                  <div>
                                    <b-button
                                      v-b-tooltip.hover
                                      v-if="
                                        deliverableStatus.length > 1 &&
                                        !isDisabledDeliverableStates
                                      "
                                      :title="$t('lbl_remove')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-danger"
                                      class="px-1 py-50 mr-75"
                                      @click="
                                        removeItem(index, deliverableStatus)
                                      "
                                    >
                                      <feather-icon size="22" icon="Trash2Icon" />
                                      <span class="sr-only">{{ $t("lbl_remove") }}</span>
                                    </b-button>
                                    <b-button
                                      v-if="
                                        index ===
                                          deliverableStatus.length - 1 &&
                                        !isDisabledDeliverableStates
                                      "
                                      v-b-tooltip.hover
                                      :title="$t('lbl_add_new')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-primary"
                                      class="px-1 py-50"
                                      @click="
                                        addNewDeliverable(deliverableStatus)
                                      "
                                    >
                                      <feather-icon size="22" icon="PlusIcon" />
                                      <span class="sr-only">{{ $t("lbl_add_new") }}</span>
                                    </b-button>
                                  </div>
                                </b-col>
                                <b-col
                                  cols="12"
                                  v-if="
                                    index !== deliverableStatus.length - 1 &&
                                    deliverableStatus.length > 1
                                  "
                                >
                                  <hr />
                                </b-col>
                              </b-row>
                            </div>
                          </b-card>
                        </div>
                        <!-- <div v-if="form.type === PRODUCT_TYPES.SERVICE">
                          <b-form-group
                            :label="$t('lbl_delivery_definition')"
                            class="mb-2 required"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_delivery_definition')"
                              rules="required"
                            >
                              <v-select
                                id="category-product-definition"
                                v-model="deliveryDefinitionSelected"
                                :label="
                                  currLanguage == 'en' ? 'title_en' : 'title'
                                "
                                value="id"
                                :clearable="true"
                                :options="deliveryDefinitionOptions"
                                :calculate-position="withPopper"
                                @input="handleSetDefinitionData"
                              >
                                <template slot="no-options">
                                  {{ $t("lbl_no_option") }}
                                </template>
                              </v-select>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-form-group
                            v-if="
                              deliveryDefinitionSelected &&
                              deliveryDefinitionSelected.id === -1
                            "
                            :label="$t('lbl_title_name_definition_config')"
                            class="mb-2 required"
                          >
                            <validation-provider
                              #default="{ errors }"
                              :name="$t('lbl_title_name_definition_config')"
                              rules="required"
                            >
                              <b-form-input v-model="definitionTitleConfig" />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                          <b-card
                            bg-variant="light"
                            v-if="deliveryDefinitionSelected !== null"
                          >
                            <div
                              class="mb-2"
                              v-if="form.type === PRODUCT_TYPES.SERVICE"
                            >
                              <h5
                                class="border-left-primary pl-50"
                                style="border-left-width: 4px"
                              >
                                {{ $t("lbl_deliverable_definition") }}
                              </h5>
                              <b-card-text>
                                {{
                                  $t(
                                    "lbl_will_be_automatically_sent_to_customer"
                                  )
                                }}
                              </b-card-text>
                              <b-row
                                v-for="(item, index) in deliverableDocs"
                                :id="item.id || item.code || index"
                                :key="item.id || item.code || index"
                                ref="row"
                              >
                                <b-col md="8">
                                  <b-form-group class="mb-md-0">
                                    <validation-provider
                                      #default="{ errors }"
                                      :vid="`input-${
                                        item.id || item.code || index
                                      }`"
                                      :name="
                                        $t('lbl_deliverable_documents_title')
                                      "
                                      rules="required"
                                    >
                                      <b-form-input
                                        type="text"
                                        :value="
                                          currLanguage == 'en'
                                            ? getTitleAttachmentEn(
                                                item.attachment_item_multilangs
                                              ) || item.title
                                            : item.title
                                        "
                                        :id="`input-${
                                          item.id || item.code || index
                                        }`"
                                        :placeholder="
                                          $t(
                                            'lbl_eg__consultation__test_results____'
                                          )
                                        "
                                        :disabled="isDisabledDeliverableDocs"
                                      />
                                      <small class="text-danger">
                                        {{ errors[0] }}
                                      </small>
                                    </validation-provider>
                                  </b-form-group>
                                </b-col>

                                <b-col md="4">
                                  <div>
                                    <b-button
                                      v-b-tooltip.hover
                                      v-if="
                                        deliverableDocs.length > 1 &&
                                        !isDisabledDeliverableDocs
                                      "
                                      :title="$t('lbl_remove')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-danger"
                                      class="px-1 py-50 mr-75"
                                      @click="
                                        removeItem(index, deliverableDocs)
                                      "
                                    >
                                      <feather-icon
                                        size="22"
                                        icon="Trash2Icon"
                                      />
                                      <span class="sr-only">
                                        {{ $t("lbl_remove") }}
                                      </span>
                                    </b-button>
                                    <b-button
                                      v-if="
                                        index === deliverableDocs.length - 1 &&
                                        !isDisabledDeliverableDocs
                                      "
                                      v-b-tooltip.hover
                                      :title="$t('lbl_add_new')"
                                      v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                      variant="outline-primary"
                                      class="px-1 py-50"
                                      @click="
                                        addNewDeliverable(deliverableDocs)
                                      "
                                    >
                                      <feather-icon size="22" icon="PlusIcon" />
                                      <span class="sr-only">
                                        {{ $t("lbl_add_new") }}
                                      </span>
                                    </b-button>
                                  </div>
                                </b-col>
                                <b-col
                                  cols="12"
                                  v-if="
                                    index !== deliverableDocs.length - 1 &&
                                    deliverableDocs.length > 1
                                  "
                                >
                                  <hr />
                                </b-col>
                              </b-row>
                            </div>
                          </b-card>
                        </div>-->
                        <div
                          v-if="
                            form.type === PRODUCT_TYPES.SERVICE &&
                            formRegisterProfile.length
                          "
                        >
                          <div class="mb-1">{{ $t("lbl_test_register_profile") }}</div>
                          <b-card bg-variant="light">
                            <h5
                              class="border-left-primary pl-50"
                              style="border-left-width: 4px"
                            >{{ $t("lbl_list_of_test_register_profile") }}</h5>
                            <b-card-text>
                              {{
                              $t(
                              "lbl_this_list_will_be_displayed_in_the_service_s_test_registration_profile"
                              )
                              }}
                            </b-card-text>
                            <div class="d-flex flex-column" style="gap: 12px">
                              <div
                                class="cursor-pointer"
                                v-for="(
                                  registerItem, index
                                ) in formRegisterProfile"
                                :key="index"
                              >
                                <div v-if="registerItem && registerItem.child">
                                  <div class="bg-white p-1 w-100">
                                    <div class="d-flex align-items-center w-100" style="gap: 8px">
                                      <input
                                        @change="
                                          (e) =>
                                            handleCollapseRegisterProfile(
                                              e,
                                              registerItem
                                            )
                                        "
                                        style="width: 16px; height: 16px"
                                        type="checkbox"
                                        class="cursor-pointer"
                                        v-model="registerItem.checked"
                                      />
                                      <div
                                        v-b-toggle="'collapse-register'"
                                        style="flex: 1; gap: 16px"
                                        class="bg-white rounded d-flex justify-content-between"
                                      >
                                        <div class="font-weight-bold">{{ registerItem.form_name }}</div>
                                        <div
                                          @click.stop="
                                            checkRequireAll(registerItem)
                                          "
                                          class="d-flex justify-content-between align-items-center"
                                          style="gap: 6px; margin-bottom: 4px"
                                        >
                                          <input
                                            v-if="registerItem.checked"
                                            class="cursor-pointer"
                                            style="width: 16px; height: 16px"
                                            type="checkbox"
                                            v-model="registerItem.isRequired"
                                          />
                                          <span
                                            v-if="registerItem.checked"
                                            class="text-danger font-italic"
                                            style="font-size: 14px"
                                          >{{ $t("lbl_required") }}</span>
                                          <br />
                                          <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            class="when-open"
                                          >
                                            <path
                                              d="M8.99991 3.58594L7.58569 5.00015L14.5857 12.0002L7.58569 19.0002L8.99991 20.4144L17.4141 12.0001L8.99991 3.58594Z"
                                              fill="#515151"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                    <b-collapse visible id="collapse-register">
                                      <div
                                        v-for="(
                                          formItem, index
                                        ) in registerItem.child"
                                        :key="`formItem-${index}`"
                                        class="d-flex align-items-center w-100 p-1 mt-1"
                                        style="
                                          background-color: #f6f6f6;
                                          gap: 8px;
                                        "
                                      >
                                        <div
                                          style="flex: 1; gap: 16px"
                                          class="rounded d-flex"
                                          @click="
                                            handleChangeFormRegisterProfile(
                                              formItem
                                            )
                                          "
                                        >
                                          <input
                                            class="cursor-pointer"
                                            style="width: 16px; height: 16px"
                                            type="checkbox"
                                            v-model="formItem.checked"
                                          />
                                          <div
                                            class="font-weight-bold"
                                            style="flex: 1"
                                          >{{ formItem.form_name }}</div>
                                        </div>
                                        <div
                                          v-if="formItem.checked"
                                          @click="
                                            () =>
                                              (formItem.isRequired =
                                                !formItem.isRequired)
                                          "
                                          class="d-flex justify-content-between align-items-center"
                                          style="gap: 6px; margin-bottom: 4px"
                                        >
                                          <input
                                            class="cursor-pointer"
                                            style="width: 16px; height: 16px"
                                            type="checkbox"
                                            v-model="formItem.isRequired"
                                          />
                                          <span
                                            class="text-danger font-italic"
                                            style="font-size: 14px"
                                          >{{ $t("lbl_required") }}</span>
                                          <br />
                                        </div>
                                      </div>
                                    </b-collapse>
                                  </div>
                                </div>
                                <div v-else class="d-flex flex-column align-items-center">
                                  <div
                                    v-if="registerItem"
                                    class="d-flex align-items-center w-100"
                                    style="gap: 8px"
                                  >
                                    <div
                                      style="gap: 16px; flex: 1"
                                      class="bg-white p-1 rounded d-flex"
                                    >
                                      <input
                                        class="cursor-pointer"
                                        style="width: 16px; height: 16px"
                                        type="checkbox"
                                        v-model="registerItem.checked"
                                      />
                                      <div
                                        style="flex: 1"
                                        @click="
                                          handleChangeFormRegisterProfile(
                                            registerItem
                                          )
                                        "
                                        class="font-weight-bold"
                                      >{{ registerItem.form_name }}</div>
                                      <div
                                        v-if="registerItem.checked"
                                        @click.self="
                                          () =>
                                            (registerItem.isRequired =
                                              !registerItem.isRequired)
                                        "
                                        class="d-flex justify-content-between align-items-center"
                                        style="gap: 6px; margin-bottom: 4px"
                                      >
                                        <input
                                          class="cursor-pointer"
                                          style="width: 16px; height: 16px"
                                          type="checkbox"
                                          v-model="registerItem.isRequired"
                                        />
                                        <span
                                          class="text-danger font-italic"
                                          style="font-size: 14px"
                                        >{{ $t("lbl_required") }}</span>
                                        <br />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </b-card>
                        </div>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <!-- attachment config -->

                <!-- <b-card
                bg-variant="light"
                v-if="deliveryStatusSelected !== null || deliveryDefinitionSelected !== null"
              >
                <div
                  class="d-flex flex-column flex-md-row justify-content-between align-items-center mb-2"
                >
                  <h4 class="mb-md-0">{{ $t('lbl_service_deliverables') }}</h4>
                  <div v-if="false">
                    <b-button
                      class="mr-50"
                      v-b-tooltip.hover
                      :title="$t('lbl_set_default_data')"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-primary"
                      size="sm"
                      @click="handleSetDefaultData"
                    >
                      <feather-icon icon="PlusCircleIcon" />
                      <span class="ml-50 sr-only">{{ $t('lbl_set_default_data') }}</span>
                    </b-button>
                    <b-button
                      v-b-tooltip.hover
                      :title="$t('lbl_reset_data')"
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="outline-danger"
                      size="sm"
                      @click="handleReset"
                    >
                      <feather-icon icon="RefreshCwIcon" />
                      <span class="ml-50 sr-only">{{ $t('lbl_reset_data') }}</span>
                    </b-button>
                  </div>
                </div>
                <div class="mb-2" v-if="form.type===PRODUCT_TYPES.SERVICE">
                  <h5
                    class="border-left-primary pl-50"
                    style="border-left-width: 4px;"
                  >{{ $t('lbl_deliverable_definition') }}</h5>
                  <b-card-text>{{ $t('lbl_will_be_automatically_sent_to_customer') }}</b-card-text>
                  <b-row
                    v-for="(item, index) in deliverableDocs"
                    :id="item.id || item.code || index"
                    :key="item.id || item.code || index"
                    ref="row"
                  >
                    <b-col md="8">
                      <b-form-group class="mb-md-0">
                        <validation-provider
                          #default="{ errors }"
                          :vid="`input-${item.id || item.code || index}`"
                          :name="$t('lbl_deliverable_documents_title')"
                          rules="required"
                        >
                          <b-form-input
                            type="text"
                            v-model="item.title"
                            :id="`input-${item.id || item.code || index}`"
                            :placeholder="$t('lbl_eg__consultation__test_results____')"
                            :disabled="isDisabledDeliverableDocs"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <div>
                        <b-button
                          v-b-tooltip.hover
                          v-if="deliverableDocs.length > 1 && !isDisabledDeliverableDocs"
                          :title="$t('lbl_remove')"
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-danger"
                          class="px-1 py-50 mr-75"
                          @click="removeItem(index, deliverableDocs)"
                        >
                          <feather-icon size="22" icon="Trash2Icon" />
                          <span class="sr-only">{{ $t('lbl_remove') }}</span>
                        </b-button>
                        <b-button
                          v-if="index === deliverableDocs.length - 1 && !isDisabledDeliverableDocs"
                          v-b-tooltip.hover
                          :title="$t('lbl_add_new')"
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-primary"
                          class="px-1 py-50"
                          @click="addNewDeliverable(deliverableDocs)"
                        >
                          <feather-icon size="22" icon="PlusIcon" />
                          <span class="sr-only">{{ $t('lbl_add_new') }}</span>
                        </b-button>
                      </div>
                    </b-col>
                    <b-col
                      cols="12"
                      v-if="index !== deliverableDocs.length - 1 && deliverableDocs.length > 1"
                    >
                      <hr />
                    </b-col>
                  </b-row>
                </div>

                <div>
                  <h5
                    class="border-left-primary pl-50"
                    style="border-left-width: 4px;"
                  >{{ $t('lbl_delivery_status_notification_check_list') }}</h5>
                  <b-card-text>{{ $t('lbl_this_will_be_shown_to_your_customer_how_they_should_await_for_package_delivery') }}</b-card-text>
                  <b-row
                    v-for="(item, index) in deliverableStatus"
                    :id="item.id || item.code || index"
                    :key="item.id || item.code || index"
                    ref="row"
                  >
                    <b-col md="8">
                      <b-form-group
                        :label="`${$t('lbl_step')} ${index + 1 < 10 ? `0${index+1}` : index + 1}`"
                        class="mb-md-0"
                      >
                        <validation-provider
                          #default="{ errors }"
                          :vid="`input-${item.id || item.code || index}`"
                          :name="$t('lbl_title_name_deliverable_status')"
                          rules="required"
                        >
                          <b-form-input
                            type="text"
                            v-model="item.title"
                            :id="`input-${item.id || item.code || index}`"
                            :placeholder="$t('lbl_ex__receiver_order__processing__sending____')"
                            :disabled="isDisabledDeliverableStates"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <div class="d-none d-md-block pb-2 mb-50"></div>
                      <div>
                        <b-button
                          v-b-tooltip.hover
                          v-if="deliverableStatus.length > 1 && !isDisabledDeliverableStates"
                          :title="$t('lbl_remove')"
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-danger"
                          class="px-1 py-50 mr-75"
                          @click="removeItem(index, deliverableStatus)"
                        >
                          <feather-icon size="22" icon="Trash2Icon" />
                          <span class="sr-only">{{ $t('lbl_remove') }}</span>
                        </b-button>
                        <b-button
                          v-if="index === deliverableStatus.length - 1 && !isDisabledDeliverableStates"
                          v-b-tooltip.hover
                          :title="$t('lbl_add_new')"
                          v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                          variant="outline-primary"
                          class="px-1 py-50"
                          @click="addNewDeliverable(deliverableStatus)"
                        >
                          <feather-icon size="22" icon="PlusIcon" />
                          <span class="sr-only">{{ $t('lbl_add_new') }}</span>
                        </b-button>
                      </div>
                    </b-col>
                    <b-col
                      cols="12"
                      v-if="index !== deliverableStatus.length - 1 && deliverableStatus.length > 1"
                    >
                      <hr />
                    </b-col>
                  </b-row>
                </div>
                </b-card>-->
              </b-form>
              <!--/ form -->
            </validation-observer>
          </div>
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="FileTextIcon" size="16" class="mr-0 mr-sm-50" />
            <span class="d-none d-sm-inline">{{ $t("lbl_certificates") }}</span>
            <!-- <feather-icon
            v-b-tooltip="{ title: 'You must select the category first', placement: 'top' }"
            icon="HelpCircleIcon"
            size="16"
            class="mr-0 ml-sm-50"
            />-->
          </template>
          <product-certificates
            :is_changed_category="is_changed_category"
            :categorySelected="categorySelected"
            :certificatesData="certificatesData"
            @setCertificates="setCertificates"
            @refresh="fetchProductCertificates"
            :productDetail="productDetail"
            class="mt-2 pt-75"
            :disable="isDisableEdit"
            :class="{ disable: isDisableEdit }"
          />
        </b-tab>
      </b-tabs>
      <b-row v-if="!isDisableEdit">
        <b-col cols="12">
          <b-button
            v-if="productId"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isLoading"
            @click="updateProduct"
          >{{ $t("lbl_update_product")[getProductTypeData()] }}</b-button>
          <b-button
            v-else
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="isLoading"
            @click="addProduct"
          >{{ $t("lbl_add_new") }}</b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            :to="{ name: 'products' }"
            variant="outline-secondary"
          >{{ $t("lbl_cancel") }}</b-button>
        </b-col>
      </b-row>
    </b-card>
    <CategoryModal
      :is-show-category-modal.sync="isShowCategoryModal"
      :type="typeCate"
      @commitData="commitData"
    />
  </div>
</template>

<script>
import { required } from '@validations'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import Cleave from 'vue-cleave-component'
import { quillEditor } from 'vue-quill-editor'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import useAddProduct from './useAddProduct'
import store from '@/store'
import appUtils from '@/utils/appUtils'
import {
  PRODUCT_ON_HODO,
  PRODUCT_TYPES,
  PRODUCT_TYPES_DATA,
  TYPE_CATE
} from '@/utils/constant'
import CategoryModal from '@/views/ProductsMarketplace/Modal/CategoryModal.vue'
import { createPopper } from '@popperjs/core'
import 'cleave.js/dist/addons/cleave-phone.vi'
import ProductCertificates from './Certificates.vue'

export default {
  name: 'AddAndUpdateProduct',
  components: {
    vSelect,
    Cleave,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    ProductCertificates,
    CategoryModal
  },
  directives: {
    Ripple
  },
  setup() {
    const mixData = useAddProduct()
    return { ...mixData }
  },
  data() {
    return {
      required,
      cleaveOptions: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand'
        }
      },
      nextTodoId: 1,
      placement: 'bottom',
      PRODUCT_TYPES,
      PRODUCT_TYPES_DATA,
      appUtils,
      isDisabledDeliverableDocs: true,
      isDisabledDeliverableStates: true,
      isDisabledAttachmentConfigs: true,
      PRODUCT_ON_HODO,
      currLanguage: this.$store.state.language.currLanguage,
      isShowCategoryModal: false,
      typeCate: 0,
      TYPE_CATE,
      valueInput: ''
    }
  },
  async created() {
    const slug = this.$route.params?.slug
    const id = slug?.split('-')?.slice(-1)

    this.productId = (id && id[0]) || null
    this.fetchCategoriesList()
    this.fetchUnitsList()
    this.fetchBrandsList()
    this.fetchOriginList()
    this.fetchManufacturerList()
    this.fetchDeliveryStatusConfigsList()
    this.fetchDeliveryDefinitionConfigsList()
    this.fetchDosageFormList()
    this.fetchSpecificationList()
    await this.handleGetConsentForm()

    this.productId &&
      this.fetchProductById().then(() => {
        this.handleSetDefaultData(this.deliveryStatusSelected)
        this.handleSetDefinitionData(this.deliveryDefinitionSelected)
        this.fetchProductCertificates()
      })

    this.$route.name === 'add-product'
      ? (this.form.type = 1)
      : (this.form.type = 2)
  },
  computed: {
    ...mapGetters('app', ['lanCodeOptions', 'statusOptions']),
    isDisableEdit() {
      return this.productDetail?.status === this.PRODUCT_ON_HODO.AVAILABLE
    },
    minimumUnit() {
      return this.form.product_variants.find(el => el.conversion_rate === 1)
    }
  },
  mounted() {
    const userData = appUtils.getLocalUser()

    if (!userData?.supplierInfo?.id) return
    this.getAttachmentConfigs(userData?.supplierInfo?.id)
  },
  methods: {
    handleLog(data) {
      this.valueInput = data
    },
    async createDosageForm(data) {
      try {
        if (!data) return
        else
          return await store
            .dispatch('configProductPartner/createDosageForm', {
              name: data,
              description: '',
              supplier_id: store.state.authenticate.userLogin.supplierInfo.id
            })
            .then(response => {
              const newID = response.data.id
              this.form.dosage_form_id = newID
              // this.toast({
              //   component: ToastificationContent,
              //   props: {
              //     title: 'Thêm dạng bào chế thành công',
              //     icon: 'CheckCircleIcon',
              //     variant: 'success'
              //   }
              // })
              return true
            })
      } catch (error) {
        console.log(error)
        // this.toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Có lỗi xảy ra khi thêm dạng bào chế',
        //     icon: 'AlertTriangleIcon',
        //     variant: 'danger'
        //   }
        // })
        return false
      } finally {
        // isLoading.value = false
      }
    },
    async createSpecification(data) {
      try {
        if (!data) return
        return await store
          .dispatch('configProductPartner/createSpecification', {
            name: data,
            description: '',
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id
          })
          .then(response => {
            const newID = response.data.id
            this.form.specification_id = newID
            // this.toast({
            //   component: ToastificationContent,
            //   props: {
            //     title: 'Thêm quy cách đóng gói thành công',
            //     icon: 'CheckCircleIcon',
            //     variant: 'success'
            //   }
            // })
            return true
          })
      } catch (error) {
        console.log(error)
        // this.toast({
        //   component: ToastificationContent,
        //   props: {
        //     title: 'Có lỗi xảy ra khi thêm quy cách đóng gói',
        //     icon: 'AlertTriangleIcon',
        //     variant: 'danger'
        //   }
        // })
        return false
      } finally {
        // isLoading.value = false
      }
    },
    async createBrand(data) {
      try {
        if (!data) return
        return await store
          .dispatch('configProductPartner/createBrand', {
            name: data,
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id
          })
          .then(response => {
            const newID = response.data.id
            this.form.brand_id = newID
            return true
          })
      } catch (error) {
        console.log(error)
        return false
      } finally {
        // isLoading.value = false
      }
    },
    async createOrigin(data) {
      try {
        if (!data) return
        return await store
          .dispatch('configProductPartner/createOrigin', {
            name: data,
            description: '',
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id
          })
          .then(response => {
            const newID = response.data.id
            this.form.origin_id = newID
            return true
          })
      } catch (error) {
        console.log(error)
        return false
      } finally {
        // isLoading.value = false
      }
    },
    async createManufacturer(data) {
      try {
        if (!data) return
        return await store
          .dispatch('configProductPartner/createManufacturer', {
            name: data,
            supplier_id: store.state.authenticate.userLogin.supplierInfo.id
          })
          .then(response => {
            const newID = response.data.id
            this.form.manufacturer_id = newID
            return true
          })
      } catch (error) {
        console.log(error)
        return false
      } finally {
        // isLoading.value = false
      }
    },
    preventInvalidNumberKey(e) {
      const invalidChars = ['-', '+', 'e', '.', ',']
      if (invalidChars.includes(e.key)) {
        e.preventDefault()
      }
    },
    preventPasteInvalidNumberKey(e) {
      let numericPattern = /^[0-9]+$/ // Regular expression to match only numeric characters from 0-9
      let copyContent = e.clipboardData.getData('text/plain')
      if (!numericPattern.test(copyContent)) {
        e.preventDefault()
      }
    },
    async commitData(data) {
      const self = this
      switch (this.typeCate) {
        case TYPE_CATE.category:
          await self.handleFetchCategory(data)
          // Danh mục
          break
        default:
      }
    },
    openCateModal(type) {
      this.isShowCategoryModal = !this.isShowCategoryModal
      this.typeCate = type
    },
    getProductTypeData(type) {
      const typeData = type || this.form.type
      return this.PRODUCT_TYPES_DATA.find(
        item => item.value === typeData
      )?.name?.toLowerCase()
    },
    checkRequireAll(registerItem) {
      registerItem.isRequired = !registerItem.isRequired
      registerItem.child.forEach(child => {
        child.isRequired = registerItem.isRequired
      })
    },
    triggerChoosePreviewImage() {
      this.$refs.refInputEl.click()
    },
    triggerChooseThumbImage() {
      this.$refs.refInputThumbEl.click()
    },
    removeImage() {
      this.$refs.refInputEl.value = null
      this.form.primary_image = null
      this.previewImg = null
    },
    removeThumbImg(index) {
      this.form.thumbnail_image && this.form.thumbnail_image?.splice(index, 1)
      this.form.thumb_images && this.form.thumb_images?.splice(index, 1)
      this.thumbsImg && this.thumbsImg.splice(index, 1)
    },
    addNewUnitItem(data) {
      data.push({
        code: appUtils.randomCode(10),
        price: null,
        unit_id: null,
        conversion_rate: null,
        default: 1,
        unit: {}
      })
    },
    addNewExpenseItem(data) {
      data.push({
        code: appUtils.randomCode(10),
        name: '',
        value: null,
        unit: 'VNĐ'
      })
    },
    addNewDeliverable(data) {
      data.push({
        code: appUtils.randomCode(10),
        title: ''
      })
    },
    removeItem(index, data, callback) {
      data.splice(index, 1)

      if (callback instanceof Function) {
        callback()
      }
    },
    handleRemoveVariant(variant_id) {
      if (isNaN(variant_id)) return

      this.$rf.getRequest('CommonRequest').deleteVariant(variant_id)
    },
    handleSelectUnit(option, index) {
      this.form.product_variants[index] = {
        ...this.form.product_variants[index],
        core_unit_id: this.minimumUnit.unit?.id || 0,
        unit_id: option.id,
        package_name: option.name,
        unit: {
          ...option,
          name_en: option.product_unit_multilanguages?.find(
            elm => elm.language == 'en'
          )?.name
        }
      }
    },
    handleSetPriceUnit(value, index) {
      this.form.product_variants[index] = {
        ...this.form.product_variants[index],
        core_unit_id: this.minimumUnit.unit?.id || 0,
        price: Number(value?.toString()?.replaceAll(',', '')) || 0
      }
    },
    handleSetUnitNumber(value, index) {
      this.form.product_variants[index] = {
        ...this.form.product_variants[index],
        number_unit: Number(value?.toString()?.replaceAll(',', '')) || 0
      }
    },
    handleSetDefaultPriceUnit(value, index) {
      this.form.product_variants = this.form.product_variants.map(
        (product, i) => {
          return {
            ...product,
            is_default: index === i ? value : 1
          }
        }
      )
      this.form.default_price = this.form.product_variants[index]?.price
      this.form.default_unit_name = this.form.product_variants[
        index
      ]?.unit?.name
      this.form.default_number_unit =
        this.form.product_variants[index]?.number_unit || 0
    },
    handleSetDefaultData(option) {
      this.deliverableStatus = (option?.delivery_state_steps?.length && [
        ...option?.delivery_state_steps
      ]) || [...this.initialDeliverables.deliverableStatus]

      if (!option?.delivery_state_steps?.length) {
        this.isDisabledDeliverableStates = false
      } else {
        this.isDisabledDeliverableStates = true
      }
    },
    handleAttachmentSetDefaultData(option) {
      this.attachementItems = (option?.order_form_items?.length && [
        ...option?.order_form_items
      ]) || [...this.initialDeliverables.attachementItems]

      if (!option?.order_form_items?.length) {
        this.isDisabledAttachmentConfigs = false
      } else {
        this.isDisabledAttachmentConfigs = true
      }
    },
    handleSetDefinitionData(option) {
      this.deliverableDocs = (option?.attachment_items?.length && [
        ...option?.attachment_items
      ]) || [...this.initialDeliverables.deliverableDocs]

      if (!option?.attachment_items?.length) {
        this.isDisabledDeliverableDocs = false
      } else {
        this.isDisabledDeliverableDocs = true
      }
    },
    handleReset() {
      this.deliverableDocs = [...this.initialDeliverables.deliverableDocs]
      this.deliverableStatus = [...this.initialDeliverables.deliverableStatus]
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1]
            }
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              )
            }
          }
        ]
      })

      return () => popper.destroy()
    },
    setCertificates(value) {
      this.certificates = (value.length && [...value]) || []
    },
    handleChangeFormRegisterProfile(item) {
      if (item.checked) {
        item.checked = false
        item.isRequired = false
      } else {
        item.checked = true
      }
    },
    handleCollapseRegisterProfile(e, data) {
      data.checked = e.target.checked
      data?.child.forEach(item => {
        item.checked = e.target.checked
      })
    },
    getTitleAttachmentEn(arr) {
      return arr?.find(elm => elm.language == 'en')?.title
    },
    getTitleStatusEn(arr) {
      return arr?.find(elm => elm.language == 'en')?.title
    }
  },
  watch: {
    '$store.state.language.currLanguage': function() {
      this.currLanguage = this.$store.state.language.currLanguage
    },
    'form.specification_id': {
      async handler(value) {
        if (typeof value === 'number' || value === null) return
        else {
          await this.createSpecification(this.valueInput)
          await this.fetchSpecificationList()
        }
      }
    },
    'form.dosage_form_id': {
      async handler(value) {
        if (typeof value === 'number' || value === null) return
        else {
          await this.createDosageForm(this.valueInput)
          await this.fetchDosageFormList()
        }
      }
    },
    'form.brand_id': {
      async handler(value) {
        if (typeof value === 'number' || value === null) return
        else {
          await this.createBrand(this.valueInput)
          await this.fetchBrandsList()
        }
      }
    },
    'form.origin_id': {
      async handler(value) {
        if (typeof value === 'number' || value === null) return
        else {
          await this.createOrigin(this.valueInput)
          await this.fetchOriginList()
        }
      }
    },
    'form.manufacturer_id': {
      async handler(value) {
        if (typeof value === 'number' || value === null) return
        else {
          await this.createManufacturer(this.valueInput)
          await this.fetchManufacturerList()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.append_cate {
  display: flex;
  flex-direction: column;
  justify-content: center;
  .btn-add-category {
    margin-left: 12px;
    padding: 6px;
    margin-top: 4px;
  }
}
.disable {
  cursor: not-allowed;
  pointer-events: none;
  .form-control,
  .v-select,
  .input-group-text,
  .thumbs-image__item-wrap,
  .quill-editor {
    background-color: #f6f6f6 !important;
    cursor: not-allowed;
    pointer-events: none;
  }
  .input-group-append,
  .btn {
    opacity: 60%;
  }
}
.preview-image {
  position: relative;
  width: 100%;

  &::before {
    content: '';
    display: block;
    padding-top: percentage(720/1200);
    transition: all 0.3s ease;
    border-radius: 4px;
  }

  &:hover::before {
    background-color: rgba(0, 0, 0, 0.05);
  }

  &__item {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__clear {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    width: 32px;
    height: 32px;
    border-radius: 4px 0 4px 0;
    line-height: 1;
    cursor: pointer;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 4px;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(0, 0, 0, 0.9);
    }
  }
}
.thumbs-image {
  &__item {
    position: relative;
    width: 25%;
    height: 52px;
    transition: all 0.3s ease;

    // &:not(:last-child) {
    //   margin-right: 8px;
    // }

    &-wrap {
      height: 100%;
      transition: all 0.3s ease;

      &:hover {
        background-color: rgba(0, 0, 0, 0.05);

        .thumbs-image__clear {
          visibility: visible;
          opacity: 1;
        }
      }

      img {
        object-fit: cover;
      }
    }
  }

  &__clear {
    display: flex;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform-origin: center;
    visibility: hidden;
    opacity: 0;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.75);
    color: white;
    transition: all 0.3s ease;
  }
}
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}

.cs-checkbox {
  position: absolute;
  top: 30px;
  right: 20px;
}

.cs-card .card-body {
  padding: 12px;
}

.not-collapsed > .when-open {
  transform: rotate(90deg);
}

.cs-close-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 26px;
  cursor: pointer;
  z-index: 10;
}
</style>
